import styles from './QuoteRowItem.module.css';

function QuoteRowItem({ children }) {
  return <li className={styles.item}>{children}</li>;
}

export default QuoteRowItem;
